// action/quotationActions.js
import { quotationsAPI } from './api';
import { productAPI } from './api';

export const quotationActions = {
    // Generic get (supports doc_type filter)
    getQuotations: async (params = {}) => {
        try {
            const response = await quotationsAPI.list(params);
            if (response?.success) {
                return { success: true, data: response.data, total: response.total, page: response.page, totalPages: response.total_pages };
            }
            return { success: false, message: response?.message, data: [] };
        } catch (error) {
            return { success: false, message: error.message, data: [] };
        }
    },
    getQuotation: async (id) => {
        try {
            const res = await quotationsAPI.get(id);
            if (res?.success) return { success: true, data: res.data };
            return { success: false, message: res?.message };
        } catch (e) { return { success: false, message: e.message }; }
    },
    createQuotation: async (data) => {
        try {
            const res = await quotationsAPI.create(data);
            if (res?.success) return { success: true, data: res.data };
            return { success: false, message: res?.message };
        } catch (e) { return { success: false, message: e.message }; }
    },
    updateQuotation: async (id, data) => {
        try { const res = await quotationsAPI.update(id, data); return { success: true, data: res.data }; }
        catch (e) { return { success: false, message: e.message }; }
    },
    deleteQuotation: async (id) => {
        try { await quotationsAPI.delete({ id }); return { success: true }; }
        catch (e) { return { success: false, message: e.message }; }
    },
    convertToSale: async (id) => {
        try { const res = await quotationsAPI.convertToSale(id); return { success: true, data: res.data }; }
        catch (e) { return { success: false, message: e.message }; }
    },
    // Proforma specific
    getProformas: async (params) => {
        params.doc_type = 'proforma';
        return quotationActions.getQuotations(params);
    },
    createProforma: async (data) => {
        data.doc_type = 'proforma';
        return quotationActions.createQuotation(data);
    },
    getProforma: async (id) => quotationActions.getQuotation(id),
    updateProforma: async (id, data) => {
        data.doc_type = 'proforma';
        return quotationActions.updateQuotation(id, data);
    },
    deleteProforma: async (id) => quotationActions.deleteQuotation(id),
    convertProformaToSale: async (id) => quotationActions.convertToSale(id),
};

// Product Actions for Quotations
export const quotationProductActions = {
    // Search products
    searchProducts: async (searchTerm) => {
        try {
            if (!searchTerm || searchTerm.length < 2) {
                return { success: true, data: [] };
            }

            const response = await productAPI.search(searchTerm);

            let products = [];
            if (Array.isArray(response)) {
                products = response;
            } else if (response && Array.isArray(response.data)) {
                products = response.data;
            } else if (response && response.products) {
                products = response.products;
            }

            const formattedProducts = products.map(product => ({
                value: product.id,
                label: `${product.product_name} (${product.sku || 'N/A'}) - ₹${product.selling_price || product.price || 0}`,
                product_name: product.product_name,
                sku: product.sku,
                selling_price: parseFloat(product.selling_price) || parseFloat(product.price) || 0,
                cost_price: parseFloat(product.cost_price) || 0,
                tax_rate: parseFloat(product.tax_rate) || 0,
                category_id: product.category_id,
                brand_id: product.brand_id,
                unit_id: product.unit_id,
                quantity: parseFloat(product.quantity) || 0,
                mrp: parseFloat(product.mrp) || 0,
                status: product.status
            }));

            return { success: true, data: formattedProducts };
        } catch (error) {
            console.error('Error searching products:', error);
            return { success: true, data: [] };
        }
    }
};

export default {
    quotationActions,
    quotationProductActions
};